export const GET_COMPANY_BRIEFING_AVAILABILITY_SUCCESS =
  'GET_COMPANY_BRIEFING_AVAILABILITY_SUCCESS';
export const GET_COACHEE_PROFILE_COMPANY_BRIEFING = 'GET_COACHEE_PROFILE_COMPANY_BRIEFING';
export const COMPANY_BRIEFING_ERROR = 'GET_COMPANY_BRIEFING_ERROR';
export const COMPANY_BRIEFING_LOADING = 'COMPANY_BRIEFING_LOADING';
